import axios from 'axios';

const API_URL = process.env.VUE_APP_API_URL + 'v1/dashboard';

class dashboardService {
    /**
     * Pobiera zamówienia posortowane według statusu.
     * 
     * @returns {Promise<Object>} Zwraca dane dotyczące zamówień, pogrupowane według ich statusów.
     */
    getOrdersByStatus() {
        return axios.get(`${API_URL}/orders-by-status`);
    }

    /**
     * Pobiera listę dostępnych kierowców.
     * 
     * @returns {Promise<Object>} Zwraca dane dotyczące wszystkich dostępnych kierowców.
     */
    getAvailableDrivers() {
        return axios.get(`${API_URL}/available-drivers`);
    }

    /**
     * Pobiera liczbe zamówienia posortowane według miesiąca.
     * 
     * @returns {Promise<Object>} Zwraca liczbe dotyczące zamówień, pogrupowane według ich miesiąca.
     */
    getOrdersByMonth() {
        return axios.get(`${API_URL}/orders-by-month`);
    }
}


export default new dashboardService();
